module.exports = __webpack_public_path__ + "img/withdrawalTime.5171470f.png";